export const help_tag_list = [
    {
        name: 'Create Supplier',
        slug: 'create-supplier',
    },
    {
        name: 'Approve Supplier',
        slug: 'approve-supplier',
    },
    {
        name: 'Create Raw Material',
        slug: 'create-raw-material',
    },
    {
        name: 'Approve Raw Material for Production',
        slug: 'approve-raw-material-production'
    },
    {
        name: 'Approve Raw Material for Production',
        slug: 'approve-raw-material-production'
    },
    {
        name: 'Create Formulation',
        slug: 'create-formulation'
    },
    {
        name: 'QC Test Formulation',
        slug: 'qc-test-formulation'
    },
    {
        name: 'Create RM Order',
        slug: 'create-rm-order'
    },
    {
        name: 'Profile Settings',
        slug: 'profile-settings'
    },
    {
        name: 'Department Setup',
        slug: 'department-setup'
    },
    {
        name: 'Staff Setup',
        slug: 'staff-setup'
    },
    {
        name: 'Supplier Types and Setup',
        slug: 'supplier-types-and-setup'
    },
    {
        name: 'Supplier RM Setup',
        slug: 'supplier-rm-setup'
    }
]